import { JointTrack } from "@/types/call";
import { Track } from "twilio-video";

export const getIsAudioOrVideoTrack = (track: Track): track is JointTrack => {
  return track.kind === "audio" || track.kind === "video";
};
